import { render, staticRenderFns } from "./Lawcore.vue?vue&type=template&id=20ad1278&"
import script from "./Lawcore.vue?vue&type=script&lang=js&"
export * from "./Lawcore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports